module.exports = __webpack_public_path__ + "static/media/seguros-mundial-icon-noneOption.ba65df9f.svg";